import getId from './randomId'
// from chrome spider.js
export const scan = (node, depth, url, parentNode) => {
  let parentId = (parentNode && parentNode.id) || ""
  if (node === null) {
    return [];
  }
  const list = [];
  while (node) {
    let control
    const black_list = ['SCRIPT', 'STYLE', 'META', 'LINK'];
    const transfer_list = ['FONT']
    const hidden_node = (node.style) && (node.style.display === 'none' || node.style.visibility === 'hidden' || node.type === 'hidden');
    const controlId = getId();
    if (black_list.includes(node.nodeName)
      || node instanceof Comment
      || hidden_node
    ) {
      node = node.nextSibling;
    } else if (node instanceof Text) {
      let text = node.data.replace(/[\n|\t]/g, '').trim();
      if (!!text && node.parentNode.tagName != 'A') {
        control = {
          id: controlId,
          controlId,
          style: {},
          spiderUrl: url,
          spiderBase: url,
          children: [],
          childrenIds: [],
          parent: parentNode || null,
          parentId: parentId,
          type: 'custom',
          name: `span-${depth}`,
          props: {
            tag: 'span',
            text: text,
            attrs: {},
            depth
          }
        }
        cleanControl(control)

        list.push(control);
      }
      node = node.nextSibling;
    } else if (node.nodeType === 1 && node.nodeName.toLowerCase() === 'svg') {
      control = {
        id: controlId,
        controlId,
        type: 'custom',
        style: getInnerNodeStyle(node, url),
        children: [],
        childrenIds: [],
        parent: parentNode || null,
        parentId: parentId,
        name: `${node.nodeName.toLowerCase()}-${depth}`,
        props: {
          tag: node.nodeName.toLowerCase(),
          attrs: getAttributes(node),
          depth,
        }
      }
      cleanControl(control)
      list.push(control)
      node = node.nextSibling;
    } else {
      let item = {
        id: controlId,
        controlId,
        tag: transfer_list.includes(node.nodeName) ? 'span' : node.nodeName.toLowerCase(),
        style: getInnerNodeStyle(node, url),
        depth,
        type: 'custom',
        name: `${node.nodeName.toLowerCase()}-${depth}`,
        props: {
          refer: 'fe_editor',
          tag: node.nodeName.toLowerCase(),
          attrs: getAttributes(node),
          depth,
        }
      };
      if (node.tagName === 'A' && node.children.length == 0) {
        item.props.text = node.textContent
      }
      // INPUT 判断
      if (node.nodeName === 'INPUT') {
        item = Object.assign(item, {
          props: {
            tag: 'input',
            attrs: {},
            refer: 'fe_editor',
            type: node.type,
            value: node.value,
            placeholder: node.placeholder
          }
        });
      }
      cleanControl(item)
      // 子元素处理
      if (node.childNodes) {
        item.children = scan(node.firstChild, depth + 1, url, item);
        item.childrenIds = item.children.map(c => c.id)
      }

      list.push(item);
      node = node.nextSibling;
    }
  }
  return list;

}


function convertStyleInfo(style) {
  let ans = {};

  for (let key in style) {
    let value = style[key];
    let camel = stringToCamel(key);
    ans[camel] = value;
  }

  return ans;

  function stringToCamel(name) {
    return name
      .split(/[-_]/)
      .map((word, index) => {
        return index ? word[0].toUpperCase() + word.slice(1) : word;
      })
      .join('');
  }
}

function styled(value, cssUrl) {
  let style = value.split(';').reduce((last, rule) => {
    const rules = rule.split(':')
    const key = rules.shift().trim()
    console.log(key, rules)
    if (key) last[key] = rules.join(':').trim()
    return last
  }, {})

  const whilteList = ['background', 'background-image', 'backgroundImage']
  whilteList.forEach(k => {
    let val = style[k], values
    if (val) {

      values = val.split(/\s+/g);
      values[0] = values[0].trim().replace(/['"]/g, '').replace(/url\((\S+)\)/, ($0, $1) => {
        const url = resolvePath($1, cssUrl);
        console.log('background url', cssUrl, url)
        style.backgroundUrl = url
        return `url("${url}")`;
      });
      style[k] = values.join(' ')
    }
  })

  return style
}

function getInnerNodeStyle(node, url) {
  // 计算内联样式
  let style = node.attributes['style'] || {}
  let style_value = style.value || '';
  let map = styled(style_value, url);
  // 样式转换
  let ans = convertStyleInfo(map);
  return ans
}

function resolvePath(src, cssHref) {
  let url = new URL(cssHref)
  cssHref = url.origin + url.pathname
  let value = '';
  if (/^https?/.test(src)) {
    value = src;
  } else if (/^data\:image\//.test(src)) {
    value = src;
  } else if (src) {
    const isRoot = src.startsWith('/');
    cssHref = cssHref.split('/').slice(0, -1).join('/')

    value = isRoot ? `${cssHref}${src}` : `${cssHref}/${src}`;
  }
  return value;
}

function getAttributes(node) {
  const IGNORE_ATTRS = ['style'];
  let attrs = [...node.attributes];

  return attrs.reduce((last, attr) => {
    if (!IGNORE_ATTRS.includes(attr.name)) {
      if (attr.name === 'href') {
        last[attr.name] = node.href
      } else {
        last[attr.name] = attr.value;
      }
    }
    return last;
  }, {});
}

function cleanControl(control) {
  let src = control.props && control.props.attrs && control.props.attrs.src
  control.props.attrs.src = {
    url: src || ''
  }
  if (control.style.backgroundUrl) {
    control.props.backgroundUrl = {
      url: control.style.backgroundUrl
    }
    delete control.style.backgroundUrl
  }
  return control
}



// WEBPACK FOOTER //
// ./src/utils/spider.js